import axios from "axios";
import "../config";

export default {
  async updateProfile(data) {
    return axios.put("/users/update-profile", data);
  },
  async workspaces() {
    return axios.get("/users/workspaces");
  },
  async getProfile({ id }) {
    return axios.get(`/users/${id}`);
  },
  async updateRole(data) {
    return axios.post("/users/update-role", data);
  },
  async removeFromWorkspace(data) {
    return axios.post("/users/remove-from-workspace", data);
  },
  async getRoles() {
    return axios.get('/users/roles');
  },
  async getInvites() {
    return axios.get("/users/pending-invites");
  },
};
